export class ListDataCatalogJoinabilityRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "namespacePath",
            "baseName": "namespacePath",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "datasetName",
            "baseName": "datasetName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDataCatalogJoinabilityRequest.attributeTypeMap;
    }
    constructor() {
    }
}
